module.exports = __webpack_public_path__ + "static/media/WonderUnitSans-200.21ddd9cf.woff2";